import { OfferState } from './-types'

export default (): OfferState => ({
  offer: '',
  sections: []
})
